import { toast } from 'react-toastify';
import PasswordResetForm from './forms/PasswordResetForm';
import paths from 'routes/paths';
import { authHelpers } from 'lib/supabase';
import { useState } from 'react';

const PasswordReset = () => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async ({ password }) => {
    setLoading(true);
    try {
      const { error } = await authHelpers.updatePassword(password);

      if (error) {
        toast.error(error.message);
      } else {
        toast.success('Password reset successfully! Please login with your new password.');
        // Sign out the temporary reset session
        await authHelpers.signOut();
        // Redirect to login
        window.location.href = paths.login;
      }
    } catch (error) {
      console.error('Password reset error:', error);
      toast.error('Something went wrong! Please try again');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="text-center">
      <h5>Reset new password</h5>
      <PasswordResetForm onSubmit={onSubmit} loading={loading} />
    </div>
  );
};

export default PasswordReset;
